module.exports = __webpack_public_path__ + "static/media/quick.c250ee07.png";